(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tur/device-services/assets/javascripts/native/native-orientation-service.js') >= 0) return;  svs.modules.push('/components/tur/device-services/assets/javascripts/native/native-orientation-service.js');

'use strict';

const _svs$tur$device$nativ = svs.tur.device.nativeBridge,
  postMessage = _svs$tur$device$nativ.postMessage,
  subscribeToMotionEvent = _svs$tur$device$nativ.subscribeToMotionEvent;
function radiansToDegrees(radians) {
  return radians * 180 / Math.PI;
}
class NativeOrientationService {
  constructor() {
    this.callbacks = new Set();
    this.handlerInstalled = false;
  }
  start() {
    postMessage('deviceMotionStart');
  }
  stop() {
    postMessage('deviceMotionEnd');
  }
  onData(callback) {
    return subscribeToMotionEvent(data => {
      const orientation = {
        roll: radiansToDegrees(data.attitude.roll),
        pitch: radiansToDegrees(data.attitude.pitch),
        yaw: radiansToDegrees(data.attitude.yaw)
      };
      callback(orientation);
    });
  }
}
setGlobal('svs.tur.device.NativeOrientationService', NativeOrientationService);

 })(window);